export class Configuration {
    mapTileDefault: string = 'tileOSM';
    language: { [key: string]: any } | null = null;
    firstDateLaunchApps: string | null = null;
}
